import { LoggedUser } from "../models/Person";

export const GUEST_ROLE_REQUIRED_ERROR = "guest_role_required";
export const GUEST_CONVERSION_EVENT = "werule:guest-conversion-required";

export function requestGuestConversionModal(): void {
  window.dispatchEvent(new CustomEvent(GUEST_CONVERSION_EVENT));
}

export function isGuestActionRestricted(
  _user: LoggedUser | null | undefined,
  _eventIntakeEnabled: boolean
): boolean {
  return false;
}

export function guardGuestAction(
  user: LoggedUser | null | undefined,
  eventIntakeEnabled: boolean,
  action: () => void
): boolean {
  if (isGuestActionRestricted(user, eventIntakeEnabled)) {
    requestGuestConversionModal();
    return false;
  }
  action();
  return true;
}

export function isGuestRoleRequiredError(error: unknown): boolean {
  const response = (error as { response?: { status?: number; data?: unknown } })?.response;
  if (response?.status !== 403) {
    return false;
  }
  const data = response.data;
  if (typeof data === "string") {
    return data === GUEST_ROLE_REQUIRED_ERROR;
  }
  if (data && typeof data === "object" && "error" in data) {
    return (data as { error?: string }).error === GUEST_ROLE_REQUIRED_ERROR;
  }
  return false;
}
